<template>
  <div class="form-wrapper">
    <h2>거래처 등록</h2>
    <hr />
    <form @submit.prevent="registerCompany">
      <div class="form-field">
        <span class="label">업체명</span>
        <input v-model="corpname" class="underline-input" />
      </div>
      <div class="form-field">
        <span class="label">주 소</span>
        <input
          v-model="address"
          class="underline-input3"
          placeholder="주소를 검색하려면 클릭하세요."
          @click="openAddressPopup"
          readonly
        />
        <input
          v-model="zipNo"
          class="underline-input2"
          placeholder="우편번호"
        />
      </div>
      <div class="form-field">
        <span class="label">대표자</span>
        <input v-model="president" class="underline-input" />
      </div>
      <div class="form-field">
        <span class="label">사업자번호</span>
        <input v-model="corpnumber" class="underline-input" />
      </div>
      <div class="form-field">
        <span class="label">휴대폰번호</span>
        <input v-model="phone" class="underline-input" />
      </div>
      <div class="form-field">
        <span class="label">이메일</span>
        <input v-model="email" class="underline-input" />
      </div>

      <div class="form-field">
        <span class="label">계약금</span>
        <input v-model="amount" class="underline-input" />
      </div>
      <div class="form-field">
        <span class="label">사용료</span>
        <input v-model="monthamount" class="underline-input" />
      </div>

      <div class="form-field">
        <span class="label">계약사항</span>
        <textarea v-model="notes" class="underline-input"></textarea>
      </div>
      <button type="submit" class="submit-btn">등록</button>
    </form>
  </div>
</template>

<script>
import { buildAddressPopupUrl, buildApiUrl, getFrontendOrigin } from "@/api";

export default {
  data() {
    return {
      corpname: "",
      address: "",
      president: "",
      corpnumber: "",
      phone: "",
      email: "",
      amount: "",
      monthamount: "",
      notes: "",
    };
  },
  methods: {
    async registerCompany() {
      try {
        const response = await fetch(buildApiUrl("register"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            corpname: this.corpname,
            address: this.address,
            president: this.president,
            corpnumber: this.corpnumber,
            phone: this.phone,
            email: this.email,
            amount: this.amount,
            monthamount: this.monthamount,
            notes: this.notes,
          }),
        });
        if (response.ok) {
          alert("업체가 성공적으로 등록되었습니다.");
          this.clearForm();
        } else {
          alert("등록 중 오류가 발생했습니다.");
        }
      } catch (error) {
        console.error(error);
        alert("서버 오류");
      }
    },
    clearForm() {
      this.corpname = "";
      this.address = "";
      this.president = "";
      this.corpnumber = "";
      this.phone = "";
      this.email = "";
      this.amount = "";
      this.monthamount = "";
      this.notes = "";
      this.zipNo = "";
    },
    openAddressPopup() {
      const popup = window.open(
        // `https://business.juso.go.kr/addrlink/addrLinkUrl.do?confmKey=U01TX0FVVEgyMDI1MDIxMTIxNTk0NzExNTQ2MzI=&returnUrl=${encodeURIComponent(location.origin)}`,
        // 'pop',
        // 'width=570,height=420,scrollbars=yes,resizable=yes'
        buildAddressPopupUrl("U01TX0FVVEgyMDI1MDIxMTIxNTk0NzExNTQ2MzI"),
        "pop",
        "width=570,height=420,scrollbars=yes,resizable=yes"
      );

      // 메시지 이벤트 리스너 추가
      window.addEventListener("message", this.handlePopupMessage, false);
    },

    handlePopupMessage(event) {
      console.log("Message received:", event);

      if (event.origin !== getFrontendOrigin()) {
        console.log("Ignored message from:", event.origin);
        return;
      }

      try {
        const data = JSON.parse(event.data);
        console.log("Parsed data:", data);

        if (data && data.roadFullAddr) {
          this.address = data.roadFullAddr;
          this.zipNo = data.zipNo;
          console.log("Address set to:", this.address);
          console.log("zipNo set to:", this.zipNo);
        }
      } catch (error) {
        console.error("JSON parse failed:", error);
      }

      window.removeEventListener("message", this.handlePopupMessage, false);
    },
  },
};
</script>

<style>
.menu-item {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.menu-item nav ul {
  display: flex;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item nav ul li {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;
  padding: 8px 16px;
  border-radius: 5px;
}

.menu-item nav ul li:hover {
  background-color: #007bff;
  color: white;
}
.footer {
  font-weight: bold;
  text-align: center;
  color: #949494;
}
.form-wrapper {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}
.form-field {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.label {
  width: 100px;
  font-size: 15px;
  font-weight: bold;
  color: #949494;
}
.underline-input {
  flex: 8;
  font-size: 15px;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  outline: none;
  transition: border-color 0.3s;
}
.underline-input3 {
  text-align: center;
  font-size: 15px;
  flex: 8;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  outline: none;
  transition: border-color 0.3s;
}
.underline-input2 {
  text-align: center;
  font-size: 15px;
  flex: 2;
  width: 95%;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  outline: none;
  transition: border-color 0.3s;
}

.underline-input:focus {
  border-bottom: 2px solid #007bff;
}
textarea.underline-input {
  resize: none;
  height: 80px;
}
.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.submit-btn:hover {
  background-color: #0056b3;
}
</style>
